<template>
  <div class="mt-20">
    <Aboutpage />
    <Playlistnos />
    <Letterform />
  </div>
</template>
<script>
import Aboutpage from "./components/Aboutpage.vue";
import Playlistnos from "./components/Playlistnos.vue";
import Letterform from "./components/Letterform.vue";
export default {
  components: {
    Aboutpage,
    Playlistnos,
    Letterform,
  },
  async mounted() {
    try {
      let data = await this.$store.dispatch("playlist/getall_category", {
        cid: this.$route.query.cid,
      });
    } catch (error) {}
  },
};
</script>
